import React from "react";
import { MessagesSquare } from "lucide-react";
import { Reveal } from "./Reveal";

export const Testimonials = () => (
  <section className="relative py-24 md:py-32" data-testid="testimonials-section">
    <div className="mx-auto max-w-3xl px-6 md:px-12">
      <Reveal>
        <div className="flex flex-col items-center rounded-[2.5rem] border border-[#2F5E43]/10 bg-white p-12 text-center shadow-[0_8px_30px_rgba(0,0,0,0.04)] md:p-16">
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#E4EDE6] text-[#2F5E43]">
            <MessagesSquare className="h-6 w-6" />
          </span>
          <p className="mt-6 text-sm font-semibold uppercase tracking-[0.15em] text-[#8AA583]">
            Testimonials
          </p>
          <h2 className="font-heading mt-4 text-4xl font-semibold leading-[1.15] tracking-tight text-[#111E16] md:text-5xl">
            Real feedback coming soon
          </h2>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-[#4A5F52]">
            We are currently welcoming our first beta testers. Their experiences will be
            shared as we grow.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
